import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { initializeIcons, loadTheme } from "@fluentui/react";

import "./index.css";

import Layout from "./pages/layout/Layout";
import Chat from "./pages/chat/Chat";
import { RouteError } from "./pages/error/RouteError";
import { SettingsContextProvider } from "./Context/SettingsContext";

initializeIcons();

// Fluent UI v8 defaults to Segoe UI; point it at the ICE font instead.
loadTheme({ defaultFontStyle: { fontFamily: "var(--idm-font-sans)" } });

const router = createBrowserRouter([
    {
        path: "/",
        element: <Layout />,
        errorElement: <RouteError />,
        children: [
            {
                index: true,
                element: <Chat />
            },
            // {
            //     path: "qa",
            //     lazy: () => import("./pages/oneshot/OneShot")
            // },
            {
                path: "*",
                lazy: () => import("./pages/NoPage")
            }
        ]
    }
]);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <SettingsContextProvider>
            <RouterProvider router={router} />
        </SettingsContextProvider>
    </React.StrictMode>
);
